import { GerenciarAtividade } from './gerenciamento-atividade.model';

export class GerenciamentoComissao extends GerenciarAtividade {
    id_instituicao: number
    id_capacitadora: number
    carga_horaria: number
    data_cadastro: Date;
    data_envio: Date;

    /**
     *Utiliza do construtor para carregar os objetos da classe
     */
    constructor(cadastro: any, listaAnexo: any[]) {
        super(cadastro, listaAnexo);
        if (cadastro.id_instituicao != null) {
            this.id_instituicao = cadastro.id_instituicao;
        }
        if (cadastro.id_capacitadora != null) {
            this.id_capacitadora = cadastro.id_capacitadora;
        }
        this.carga_horaria = cadastro.carga_horaria;
    }
}


// WEBPACK FOOTER //
// ./src/app/entity/gerenciamento-comissao.model.ts